import React from 'react';
import { FaCommentDots } from 'react-icons/fa';

function formatPreviewTime(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    return isToday
        ? date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        : date.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

/**
 * ChatList — podcaster's sidebar listing all listener threads for a club.
 *
 * Props:
 *   chats           array   — from useChatStore
 *   activeChatGuid  string  — currently open thread
 *   onSelect        (chat) => void
 *   clubTitle       string
 */
export default function ChatList({ chats, activeChatGuid, onSelect, clubTitle }) {
    return (
        <div className="chat-list">
            <div className="chat-list__header">
                <FaCommentDots className="chat-list__header-icon" />
                <div className="chat-list__header-text">
                    <span className="chat-list__club-title">{clubTitle}</span>
                    <span className="chat-list__subtitle">Listener Conversations</span>
                </div>
            </div>

            <div className="chat-list__threads">
                {chats.length === 0 && (
                    <div className="chat-list__empty">
                        No conversations yet. Open a listener's profile to start one.
                    </div>
                )}

                {chats.map((chat) => {
                    const listener = chat.listener;
                    const name = listener
                        ? `${listener.first_name ?? ''} ${listener.last_name ?? ''}`.trim()
                        : 'Listener';
                    const initial = (listener?.first_name ?? '?')[0].toUpperCase();
                    const isActive = chat.listener_guid === activeChatGuid;
                    const latest = chat.latest_message;

                    return (
                        <button
                            key={chat.chat_guid}
                            className={`chat-list__item ${isActive ? 'chat-list__item--active' : ''}`}
                            onClick={() => onSelect(chat)}
                        >
                            <div className="chat-list__item-avatar">
                                {listener?.avatar_url ? (
                                    <img src={listener.avatar_url} alt={name} />
                                ) : (
                                    <span>{initial}</span>
                                )}
                            </div>

                            <div className="chat-list__item-body">
                                <div className="chat-list__item-top">
                                    <span className="chat-list__item-name">{name}</span>
                                    {latest && (
                                        <span className="chat-list__item-time">
                                            {formatPreviewTime(latest.created_at)}
                                        </span>
                                    )}
                                </div>
                                {latest && (
                                    <span className="chat-list__item-preview">
                                        {latest.message?.slice(0, 55)}
                                        {latest.message?.length > 55 ? '…' : ''}
                                    </span>
                                )}
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
